import "./App.css";
import GlobalPopup from "./components/popup/GlobalPopup";
import Router from "./router/Router";

function App() {
  return (
    <>
      <Router />
      <GlobalPopup />
    </>
  );
}

export default App;
